import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CategoryName from '../../shared/CategoryName';
import Options from '../VehicleDetails/Options';

const useStyles = makeStyles(theme => ({
  options: {
    marginBottom: '60px',
    marginTop: '60px'
  }
}));

function Summary({ vehicle }) {
  const classes = useStyles();

  return (
    <div className="section vehicle-summary">
      <div className="category">
        {vehicle.category_id && (
          <CategoryName categoryId={vehicle.category_id} />
        )}
      </div>
      <div className="model">
        {vehicle.make} {vehicle.model} {vehicle.year}
      </div>
      <div className={classes.options}>
        <Options
          doors={vehicle.doors_count}
          seats={vehicle.seats_count}
          fuel={vehicle.fuel_type}
          transmission={vehicle.gears_type}
        />
      </div>
    </div>
  );
}

export default Summary;
